import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useTranslation } from 'react-i18next';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { localeMap } from '../constants/locales';

export default function DateProvider({ children }) {
  const { i18n } = useTranslation();

  const locale =
    localeMap[i18n.language] || localeMap.en;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={locale}
    >
      {children}
    </LocalizationProvider>
  );
}
